import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ItemWithStatus } from '../types/ChemicalSkid';

interface LegendState {
    risks: ItemWithStatus[]
    skid_status: ItemWithStatus[]
    chemical_availability: ItemWithStatus[]
}

const initialState: LegendState = {
    risks: [],
    skid_status: [],
    chemical_availability: []
};

const legendSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setLegendInfo: (state, action: PayloadAction<Partial<LegendState>>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setLegendInfo } = legendSlice.actions;
export default legendSlice.reducer;